import { useEffect, useState } from 'react';
import '../css/CadastrarPontoMototaxi.css';
import { useNavigate } from 'react-router-dom';
import { aplicarMascaraTelefone } from '../uteis/mascaras/mascaraTelefone';
import { aplicarMascaraCep } from '../uteis/mascaras/mascaraCep';
import { UFs } from '../uteis/constantes/ufs';
import { useLocation } from 'react-router-dom';


import Cookies from 'js-cookie'; 


// API
import { atualizarPontoMototaxi, cadastrarPontoMototaxi } from '../servicos/cadastroServico';

// valore iniciais para servir de base tanto no useState quanto na limpeza:
const valoresIniciais = {
    name: '',
    email: '',
    nome_responsavel_pelo_ponto: '',
    senha: '',
    confirma_senha: '',
    servicos: [],
    representante_comercial_id: '',
    latitude: '',
    longitude: '',
    caminho_logomarca: '',
    endereco: '',
    bairro: '',
    cidade: '',
    uf: '',
    cep: '',
    numero_celular_com_ddd: '',
    observacao: '',
    st_is_ativo: true,
    data_inicio_vigencia: '',
    data_fim_vigencia: '',
  };

    

function CadastrarPontoMototaxi() {

  const navigate = useNavigate();

  const location = useLocation();
  const pontoEditando = location.state?.ponto;

  const BASE_URL =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://127.0.0.1:8000' 
      : 'https://mercadinhointeligente.com.br';

  useEffect(() => {
    if (pontoEditando) {

      console.log('Modo edição detectado. Preenchendo formulário com os dados...');
      console.log('Dados do ponto: ');
      console.log(pontoEditando);

      setForm((prevForm) => ({
        ...prevForm,
        ...pontoEditando,
        email: pontoEditando.user?.email || '',
        name: pontoEditando.user?.name || '',
        nome_responsavel_pelo_ponto: pontoEditando.nome_responsavel_pelo_ponto || '',
        numero_celular_com_ddd: pontoEditando.numero_celular_com_ddd || '',
        endereco: pontoEditando.endereco || '',
        bairro: pontoEditando.bairro || '',
        cidade: pontoEditando.cidade || '',
        uf: pontoEditando.uf || '',
        cep: pontoEditando.cep || '',
        data_inicio_vigencia: pontoEditando.data_inicio_vigencia || '',
        data_fim_vigencia: pontoEditando.data_fim_vigencia || '',
        observacao: pontoEditando.observacao || '',
        st_is_ativo: pontoEditando.st_is_ativo,
        latitude: pontoEditando.latitude || '',
        longitude: pontoEditando.longitude || '',
        servicos: pontoEditando.servicos_atendidos?.map((s) => s.id_tipo_servico) || [],
        // ⚠️ senha e confirma_senha ficam vazios para segurança
        senha: '',
        confirma_senha: '',
      }));
    }
  }, [pontoEditando]);
  


  const listaServicos = [
    { id: 1, nome: 'Mototáxi', descricao: 'Serviço de transporte de passageiros' },
    { id: 2, nome: 'Encomendas pequenas', descricao: 'Entrega de pequenas encomendas' },
    // { id: 3, nome: 'gas', descricao: 'Entrega de gás' },
    { id: 4, nome: 'Material de Construção', descricao: 'Entrega de material de construção' },
    { id: 5, nome: 'Bebidas', descricao: 'Entrega de bebidas' },
    { id: 6, nome: 'Supermercado', descricao: 'Serviço de compras em geral' },
    { id: 7, nome: 'Banco', descricao: 'Serviço de ida ao banco' },
    { id: 8, nome: 'Farmácia', descricao: 'Serviço de ida á farmácia' }
  ];
  

  // limpar o formulário
  const [form, setForm] = useState(valoresIniciais);

    // ✅ Mostra os cookies no console ao carregar o componente
    useEffect(() => {

        console.log('Entrou no useEffect do Cadastrar Ponto Mototaxi....');

        const cookies = Cookies.get(); // retorna objeto
        //  com todos os cookies
        const dadosCookiesString = cookies.dadosCookies;
    
        if (dadosCookiesString) {
            try {
                const dadosCookies = JSON.parse(dadosCookiesString); // transforma string em objeto
                const dadosUsuario = dadosCookies.dadosUsuario;
                const perfis = dadosCookies.perfis;
                const dadosRepresentanteComercial = dadosCookies.dadosRepresentanteComercial;
                const idRepresentanteComercial = dadosRepresentanteComercial.id;
                
                // vamos setar o id do representante comercial logado
                setForm((prevForm) => ({
                    ...prevForm,
                    representante_comercial_id: idRepresentanteComercial
                }));                  
    
                console.log('Dados cookies:', dadosCookies);
                console.log('Dados usuário:', dadosUsuario);
                console.log('Dados representante comercial', dadosRepresentanteComercial);
                console.log('Id representante comercial', idRepresentanteComercial);
                console.log('Perfis:', perfis);
            } catch (e) {
                console.error('Erro ao fazer parse dos dadosCookies:', e);
            }
        } else {
            console.warn('Cookie "dadosCookies" não encontrado');
        }
    }, []);
    



  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setForm((prevForm) => ({
            ...prevForm,
            latitude: position.coords.latitude.toString(),
            longitude: position.coords.longitude.toString(),
          }));
        },
        (error) => {
          console.error("Erro ao obter localização:", error);
        }
      );
    } else {
      console.error("Geolocalização não suportada pelo navegador.");
    }
  }, []);
  
  const atualizarLocalizacao = () => {
    console.log('Entrou em Atualizar Localização...');

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
            console.log('posição atual: ');
            console.log(position);

          setForm((prevForm) => ({
            ...prevForm,
            latitude: position.coords.latitude.toString(),
            longitude: position.coords.longitude.toString(),
          }));
        },
        (error) => {
          console.error("Erro ao obter localização:", error);
          alert("Não foi possível obter sua localização. Verifique as permissões do navegador.");
        }
      );
    } else {
      alert("Geolocalização não é suportada pelo seu navegador.");
    }    
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setForm((prevForm) => ({
      ...prevForm,
      caminho_logomarca: file,
    }));
  };
  
  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'servicos') {
        const valorNumerico = parseInt(value);
        const updatedServicos = checked
          ? [...form.servicos, valorNumerico]
          : form.servicos.filter((s) => s !== valorNumerico);
      
        setForm((prevForm) => ({
          ...prevForm,
          servicos: updatedServicos,
        }));
    } else {
        let newValue = value;
      
        // if (name === 'telefone') {
        //   newValue = aplicarMascaraTelefone(value);
        // }
      
        if (name === 'cep') {
          newValue = aplicarMascaraCep(value);
        }
      
        setForm((prevForm) => ({
          ...prevForm,
          [name]: type === 'checkbox' ? checked : newValue,
        }));
      }
  };

  const handleSubmit = async (e) => {

    console.log('-----------------------------');
    console.log('Entrou em handleSubmit do CAdastrar Ponto Mototaxi....');
    console.log('Preparando para fazer as validações....');

    console.log('Dados do formulário:', form);
    
    e.preventDefault();


    /**
     * Vamos verificar se é cadastro ou edição
     */
    if (pontoEditando && pontoEditando.id) {
        console.log('Entrou na parte de edição de ponto...');
    
        try {
            const formData = new FormData();
    
            for (const key in form) {
                if (key === 'servicos') {
                    form.servicos.forEach((s, idx) => {
                        formData.append(`servicos[${idx}]`, s);
                    });
                } else if (key === 'caminho_logomarca' && form[key]) {
                    formData.append('imagem', form[key]);
                } else {
                    formData.append(key, form[key]);
                }
            }
    
            const formDataObject = {};
            formData.forEach((value, key) => {
                formDataObject[key] = value;
            });
            console.log('FormData como objeto (edição):', formDataObject);
    
            const resposta = await atualizarPontoMototaxi(formData, pontoEditando.id);
    
            alert('Ponto de Mototáxi atualizado com sucesso!');
            console.log('Resposta (edição):', resposta);
    
            setForm(valoresIniciais); // limpar formulário
            atualizarLocalizacao();   // atualizar localização
            navigate('/listar-ponto-mototaxi');
        } catch (erro) {
            alert('Erro ao atualizar ponto.');
            console.log('Erro:', erro);
        }
    
    } else {
        console.log('Entrou na parte de cadastro de novo ponto...');
        // chamada ao cadastrarPontoMototaxi como já existe
        // Início da Validação básica (exceto observação)
            const camposObrigatorios = [
                'representante_comercial_id',
                'name', // Nome do ponto
                'email',
                'nome_responsavel_pelo_ponto',
                'senha',
                'confirma_senha',
                'endereco',
                'bairro',
                'cidade',
                'uf',
                'cep',
                'numero_celular_com_ddd',
                'data_inicio_vigencia',
                'latitude',
                'longitude',
                'servicos'
            ];
            
            for (let campo of camposObrigatorios) {
                if (
                    (Array.isArray(form[campo]) && form[campo].length === 0) || 
                    (!Array.isArray(form[campo]) && !form[campo])
                ) {
                
                    alert(`O campo "${campo}" é obrigatório.`);
                    return;
                }
            }
        // fim validação básica

        if (form.senha !== form.confirma_senha) {
        alert("As senhas não coincidem!");
        return;
        }

        console.log('ok, validações feitas.');


        try {
            const formData = new FormData();
        
            // Campos simples
            console.log('Preparando para gerar os dados no formData....');
            for (const key in form) {

                console.log('key: ');
                console.log(key);

            if (key === 'servicos') {
                form.servicos.forEach((s, idx) => {
                formData.append(`servicos[${idx}]`, s);
                });
            } else if (key === 'caminho_logomarca' && form[key]) {
                formData.append('imagem', form[key]); // <- aqui vai a logomarca
            } else {
                formData.append(key, form[key]);
            }
            }

            // tudo isso pra mostrar no console:
            const formDataObject = {};
            formData.forEach((value, key) => {
            formDataObject[key] = value;
            });
            console.log('FormData como objeto:', formDataObject);
        
            const resposta = await cadastrarPontoMototaxi(formData); // <-- atualize essa função se necessário
        
            alert('Ponto de Mototáxi cadastrado com sucesso!');
            console.log('Resposta:', resposta);
        
            setForm(valoresIniciais); // limpar formulário
            atualizarLocalizacao();   // atualizar localização
            navigate('/listar-ponto-mototaxi');
        } catch (erro) {
            alert('Erro ao cadastrar ponto.');
            console.log('Erro:', erro);
        }
        


    }
      


    
  };

  return (
    <div className="card p-4 shadow-sm" style={{ width: '100%', maxWidth: '600px', margin: '2rem auto' }}>
      <div className="card-body">
        <h3 className="text-center mb-4">Cadastrar Ponto de Mototáxi</h3>

        <form onSubmit={handleSubmit}>

          {/* Bloco 1: Usuário, email e senha */}
          <div className="mb-4 border p-3 rounded">
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                placeholder="Nome"
                value={form.name}
                onChange={handleChange}
                required
              />
              <label htmlFor="name">Nome do Ponto</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                placeholder="E-mail"
                value={form.email}
                onChange={handleChange}
                required
              />
              <label htmlFor="email">E-mail do Ponto</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="nome_responsavel_pelo_ponto"
                name="nome_responsavel_pelo_ponto"
                placeholder="Nome do Responsável pelo Ponto"
                value={form.nome_responsavel_pelo_ponto}
                onChange={handleChange}
                required
              />
              <label htmlFor="name">Nome do Responsável pelo Ponto</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="password"
                className="form-control"
                id="senha"
                name="senha"
                placeholder="Senha"
                value={form.senha}
                onChange={handleChange}
                required
                disabled={Boolean(pontoEditando)}
              />
              <label htmlFor="senha">Senha</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="password"
                className="form-control"
                id="confirma_senha"
                name="confirma_senha"
                placeholder="Confirmar Senha"
                value={form.confirma_senha}
                onChange={handleChange}
                required
                disabled={Boolean(pontoEditando)}
              />
              <label htmlFor="confirma_senha">Confirmar Senha</label>
            </div>
          </div>

          {/* Bloco 2: Endereço e telefone */}
          <div className="mb-4 border p-3 rounded">
            {[
              ['cep', 'CEP'],
              ['endereco', 'Endereço'],
              ['bairro', 'Bairro'],
              ['cidade', 'Cidade'],
              
              
            ].map(([field, label]) => (
              <div className="form-floating mb-3" key={field}>
                <input
                  type="text"
                  className="form-control"
                  id={field}
                  name={field}
                  placeholder={label}
                  value={form[field]}
                  onChange={handleChange}
                  required
                />
                <label htmlFor={field}>{label}</label>
              </div>
            ))}

            <div className="form-floating mb-3">
                <select
                    className="form-select"
                    id="uf"
                    name="uf"
                    value={form.uf}
                    onChange={handleChange}
                    required
                >
                    <option value="">Selecione o estado</option>
                    {UFs.map((uf) => (
                    <option key={uf.sigla} value={uf.sigla}>
                        {uf.nome}
                    </option>
                    ))}
                </select>
                <label htmlFor="uf">UF</label>
            </div>




            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="numeroCelular"
                name="numero_celular_com_ddd"
                // placeholder="(83) 91234-5678"
                value={form.numero_celular_com_ddd}
                onChange={(e) => {
                  const valorFormatado = aplicarMascaraTelefone(e.target.value);
                  setForm((prevForm) => ({
                    ...prevForm,
                    numero_celular_com_ddd: valorFormatado,
                  }));
                }}
                maxLength={15}
                required
              />
              <label htmlFor="numeroCelular">Celular com DDD</label>
            </div>

          </div>

          {/* Bloco 3: Ativo, vigência e observações */}
          <div className="mb-4 border p-3 rounded">
            <div className="form-check form-switch mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="ativoCheck"
                name="st_is_ativo"
                checked={form.st_is_ativo}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="ativoCheck">
                Ativo
              </label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="date"
                className="form-control"
                id="inicioVigencia"
                name="data_inicio_vigencia"
                value={form.data_inicio_vigencia}
                onChange={handleChange}
                required
              />
              <label htmlFor="inicioVigencia">Início da Vigência</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="date"
                className="form-control"
                id="fimVigencia"
                name="data_fim_vigencia"
                value={form.data_fim_vigencia}
                onChange={handleChange}
              />
              <label htmlFor="fimVigencia">Fim da Vigência</label>
            </div>

            <div className="form-floating mb-3">
              <textarea
                className="form-control"
                id="observacao"
                name="observacao"
                placeholder="Observações"
                value={form.observacao}
                onChange={handleChange}
                style={{ height: '100px' }}
              />
              <label htmlFor="observacao">Observações</label>
            </div>
          </div>

          <h5 className="mb-2 mt-4">Serviços oferecidos:</h5>

            <div className="mb-4 border p-3 rounded">
                <div className="row">

                    {listaServicos.map((servico) => (
                    <div className="col-6 col-md-4 mb-2" key={servico.id}>
                        <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={`servico-${servico.id}`}
                            name="servicos"
                            value={servico.id} // envia o ID
                            // checked={form.servicos.includes(servico.id.toString())} // compara como string
                            checked={form.servicos.includes(servico.id)}
                            onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor={`servico-${servico.id}`}>
                            {servico.nome}
                        </label>
                        </div>
                    </div>
                    ))}

                </div>
            </div>



            <div className="mb-4 border p-3 rounded">
                <h5 className="mb-3">Localização</h5>
                <div className="mb-3">
                    <label htmlFor="latitude" className="form-label">Latitude:</label>
                        <input
                        type="text"
                        className="form-control"
                        id="latitude"
                        name="latitude"
                        value={form.latitude}
                        readOnly
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="longitude" className="form-label">Longitude:</label>
                    <input
                        type="text"
                        className="form-control"
                        id="longitude"
                        name="longitude"
                        value={form.longitude}
                        readOnly
                    />                    
                </div>
                <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={atualizarLocalizacao}
                >
                    Atualizar Localização do Ponto
                </button>
            </div>

            <div className="mb-4 border p-3 rounded">
                <h5 className="mb-3">Logomarca do Ponto</h5>
                <div className="mb-3">
                    <label htmlFor="logomarca" className="form-label">Selecionar Logomarca:</label>
                    <input
                      type="file"
                      className="form-control"
                      id="logomarca"
                      name="logomarca"
                      accept="image/*"
                      onChange={handleFileChange}
                    />



{/*
  Exibe apenas quando estamos em modo edição (pontoEditando).
  Usa o caminho fixo solicitado para a logomarca, baseado no ID do ponto.
*/}
{pontoEditando && pontoEditando.id && (() => {
  const imagemLogomarca = `${BASE_URL}/storage/imagens/pontoMotoTaxi/logomarca_ponto_mototaxi_${pontoEditando.id}.png`;
  console.log('DEBUG - imagemLogomarca (edição):', imagemLogomarca);

  return (
    <div className="mb-3">
      <label className="form-label">Logomarca atual:</label>
      <div>
        <a href={imagemLogomarca} target="_blank" rel="noopener noreferrer">
          <img
            src={imagemLogomarca}
            alt={`Logomarca do ponto ${pontoEditando.id}`}
            className="img-fluid rounded"
            style={{ maxWidth: '200px', height: 'auto' }}
            onError={(e) => {
              // esconde imagem quebrada e registra no console para debug
              e.currentTarget.style.display = 'none';
              console.warn('Logomarca não encontrada em:', imagemLogomarca);
            }}
          />
        </a>
      </div>
    </div>
  );
})()}



                </div>
            </div>


          <button type="submit" className="btn btn-primary w-100">Salvar Ponto</button>
        </form>
      </div>
    </div>
  );
}

export default CadastrarPontoMototaxi;
